var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrepIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.92,
    height: 48.92,
    viewBox: "0 0 36.92 48.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prep_Icon",
    "data-name": "Prep Icon",
    transform: "translate(-12.54 -7.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13512",
    "data-name": "Path 13512",
    d: "M44.51,7.54H17.49a4.955,4.955,0,0,0-4.95,4.95V51.51a4.955,4.955,0,0,0,4.95,4.95H44.51a4.955,4.955,0,0,0,4.95-4.95V12.49a4.955,4.955,0,0,0-4.95-4.95Zm3.03,43.97a3.034,3.034,0,0,1-3.03,3.03H17.49a3.034,3.034,0,0,1-3.03-3.03V12.49a3.034,3.034,0,0,1,3.03-3.03H44.51a3.034,3.034,0,0,1,3.03,3.03V51.51Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13513",
    "data-name": "Path 13513",
    d: "M34.23,17.93l-4.5,6.1L27.7,21.85a.955.955,0,1,0-1.4,1.3l3.6,3.87,5.87-7.95a.958.958,0,0,0-1.54-1.14Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13514",
    "data-name": "Path 13514",
    d: "M35.75,13.54H26.24a3.7,3.7,0,0,0-3.7,3.7v9.51a3.7,3.7,0,0,0,3.7,3.7h9.51a3.7,3.7,0,0,0,3.7-3.7V17.24A3.7,3.7,0,0,0,35.75,13.54Zm1.79,13.21a1.788,1.788,0,0,1-1.79,1.79H26.24a1.788,1.788,0,0,1-1.79-1.79V17.24a1.788,1.788,0,0,1,1.79-1.79h9.51a1.788,1.788,0,0,1,1.79,1.79Z",
    fill: "#d0d6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13515",
    "data-name": "Path 13515",
    d: "M34.23,37.9l-4.5,6.11L27.7,41.82a.955.955,0,0,0-1.4,1.3L29.9,47l5.87-7.97a.958.958,0,1,0-1.54-1.14Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13516",
    "data-name": "Path 13516",
    d: "M35.75,33.5H26.24a3.713,3.713,0,0,0-3.7,3.71v9.53a3.707,3.707,0,0,0,3.7,3.71h9.51a3.713,3.713,0,0,0,3.7-3.71V37.21A3.707,3.707,0,0,0,35.75,33.5Zm1.79,13.24a1.8,1.8,0,0,1-1.79,1.8H26.24a1.8,1.8,0,0,1-1.79-1.8V37.21a1.8,1.8,0,0,1,1.79-1.8h9.51a1.8,1.8,0,0,1,1.79,1.8Z",
    fill: "#d0d6ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepIcon);
export default __webpack_public_path__ + "static/media/Prep Icon.c1cf1b28077de7d6cedc15291cf8dacd.svg";
export { ForwardRef as ReactComponent };